import { convertMusicProductDigitalQueryToForm as queryToForm } from "./musicProductDigitalQueryToForm";
import { convertTracksToAlbumsForm as tracksToAlbums } from "./tracksToAlbums";
import { musicProductDigitalFormToQuery as formToQuery } from "./musicProductDIgitalFormToQuery";
import { settlementInfoFormToQuery } from './settlementInfoFormToQuery';

export default { tracksToAlbums, queryToForm, formToQuery, settlementInfoFormToQuery };
